import React from 'react';
import { useHistory } from 'react-router-dom';
import { vsprintf } from 'sprintf-js';
import RoutePath from 'routes/constants/routes';
import placeholder from 'media/images/placeholder.jpg';
import { textTrim } from 'utils/text';
import { getAuthorsLabel } from 'utils/books';
import { BooksType, IBooksCardProps } from './BooksCardTypes';
import {
  BooksCardContainer,
  BooksCardCover,
  BooksCardDescription,
  BooksCardDescriptionName,
  BooksCardDescriptionAuthors,
} from './BooksCardStyles';

function BooksCard(props: IBooksCardProps) {
  const {
    item,
    priorityPreview = BooksType.EBOOK,
  } = props;

  const {
    name,
    authors: authorsBase,
    bookId,
    abookPreview,
    ebookPreview,
  } = item;

  const history = useHistory();

  const handleRedirect = () => history.push(vsprintf(RoutePath.BOOKS_DETAIL_PATH, [bookId]));

  const preview = (priorityPreview === BooksType.ABOOK && abookPreview) ? abookPreview : ebookPreview;
  const authors = getAuthorsLabel(authorsBase);

  return (
    <BooksCardContainer onClick={handleRedirect}>
      <BooksCardCover
        src={preview}
        alt={name}
        onError={(e: any) => {
          e.target.onerror = null;
          e.target.src = placeholder;
        }}
      />
      <BooksCardDescription>
        <BooksCardDescriptionName>{textTrim(name, 38)}</BooksCardDescriptionName>
        <BooksCardDescriptionAuthors>{textTrim(authors, 18)}</BooksCardDescriptionAuthors>
      </BooksCardDescription>
    </BooksCardContainer>
  );
}

export default BooksCard;
